import { useAction, useAtom } from '@reatom/npm-react'
import { useMemo } from 'react'
import React from 'react'
import { useMount } from 'react-use'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { CircularLoader } from '@blade/ui-kit'
import { RectangleNetworkBackground } from '@root/shared/ui'
import { InfoMessage } from '@root/shared/ui-kit'

import { blueskyPostOembed } from '../atoms/bluesky-post-oembed'

import { BlueskyEmbedPost } from './bluesky-embed-post'

import type * as KnownSocialPlatformResource from '../model/known-social-platform-resource'

interface SocialBlueskyEmbedProps {
  onLoad: () => void
  resource: KnownSocialPlatformResource.BlueskyKnownSocialPlatformResource
}

export const SocialBlueskyEmbed = React.memo(
  function SocialBlueskyEmbed({ resource, onLoad }: SocialBlueskyEmbedProps) {
    const model = useMemo(() => blueskyPostOembed({ resource }), [resource])
    const [requestState] = useAtom(model.requestModel)
    const refresh = useAction(model.requestModel.execute)

    useMount(() => {
      onLoad()
    })

    return AsyncStateN.matchWaiting(requestState, {
      Waiting: () => (
        <Root>
          <Loader />
        </Root>
      ),
      Error: () => (
        <Root>
          <InfoMessage intent={'error'} onRetry={refresh} />
        </Root>
      ),
      Success: (oembed) => <BlueskyEmbedPost html={oembed.html} />,
    })
  },
  (prevProps, nextProps) => {
    return prevProps.resource.url === nextProps.resource.url
  },
)

const Root = styled.div`
  ${RectangleNetworkBackground}

  width: 350px;
  min-height: fit-content;
  position: relative;
  border: 1px solid var(--background-6);
  border-radius: 32px;
  overflow: hidden;
`

const Loader = () => (
  <LoaderRoot>
    <CircularLoader size={24} />
  </LoaderRoot>
)

const LoaderRoot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 160px;
`
